
import {
    GET_PRODUCTS_FAILED,
    GET_PRODUCTS_LOADING,
    GET_PRODUCTS_SUCCESS,
    GET_RECIPES_FAILED,
    GET_RECIPES_LOADING,
    GET_RECIPES_SUCCESS,
    UPDATE_VIEWED_LOCATION,
    PRODUCT_IMAGES_LOADING,
    TOGGLE_NAV,
    TOGGLE_CONTACT,
    TOGGLE_SINGLE_PRODUCT,
    GET_SINGLE_PRODUCT_LOADING,
    TOGGLE_SINGLE_EVENT,
    TOGGLE_SEARCH,
    GET_EVENTS_SUCCESS,
    GET_EVENTS_LOADING,
    GET_EVENTS_FAILED,
    TOGGLE_NUTRITION,
    SET_NUTRI_FACTS_IMAGE
} from '../constants'

const initialState = {
    singleProductOpen: false,
    singleEventOpen: false,
    contactType: 'bimbo',
    contactOpen: false,
    isSearchActive: false,
    hoveredCell: null,
    getProductsLoading: false,
    getProductsFailed: false,
    getRecipesLoading: false,
    getRecipesFailed: false,
    getEventsLoading: false,
    getEventsFailed: false,
    getSingleProductLoading: false,
    getSingleProductFailed: false,
    getSingleRecipeLoading: false,
    getSingleRecipeFailed: false,
    products: [],
    recipes: [],
    events: [],
    navOpen: false,
    productImagesLoading: true,
    nutritionalFactsOpen: false,
    nutritionalFactImage: null
}

const getRecipesFailed = (state, action) => {
    return Object.assign({}, state, {
        getRecipesFailed: true,
        getRecipesLoading: false,
        errorMessage: action.msg
    })
}

const toggleNutritionalFacts = (state, action) => {
    return Object.assign({}, state, {
        nutritionalFactsOpen: action.bool
    })
}

const getRecipesLoading = (state, action) => {
    let obj = {}
    obj.getProductsLoading = action.bool
    if (action.bool) {
        obj.getRecipesSuccess = false
        obj.getRecipesFailed = false
    }
    return Object.assign({}, state, {
        ...obj
    })
}

const getRecipesSuccess = (state, action) => {
    return Object.assign({}, state, {
        getRecipesFailed: false,
        getRecipesLoading: false,
        recipes: action.result.data
    })
}

const getProductsFailed = (state, action) => {
    return Object.assign({}, state, {
        getProductsFailed: true,
        getProductsLoading: false,
        errorMessage: action.msg
    })
}

const getProductsLoading = (state, action) => {
    let obj = {}
    obj.getProductsLoading = action.bool
    if (action.bool) {
        obj.getProductsSuccess = false
        obj.getProductsFailed = false
    }
    return Object.assign({}, state, {
        ...obj
    })
}

const getProductsSuccess = (state, action) => {
    return Object.assign({}, state, {
        getProductsFailed: false,
        getProductsLoading: false,
        products: action.result.data
    })
}

const getEventsFailed = (state, action) => {
    return Object.assign({}, state, {
        getEventsFailed: true,
        getEventsLoading: false,
        errorMessage: action.msg
    })
}

const getEventsLoading = (state, action) => {
    let obj = {}
    obj.getEventsLoading = action.bool
    if (action.bool) {
        obj.getEventsSuccess = false
        obj.getEventsFailed = false
    }
    return Object.assign({}, state, {
        ...obj
    })
}

const getEventsSuccess = (state, action) => {
    return Object.assign({}, state, {
        getEventsFailed: false,
        getEventsLoading: false,
        events: action.result.data
    })
}

const toggleNav = (state, action) => {
    return Object.assign({}, state, {
        navOpen: action.bool
    })
}

const toggleContact = (state, action) => {
    return Object.assign({}, state, {
        contactOpen: action.bool,
        contactType: action.contactType
    })
}

const mainReducer = (state = initialState, action) => {

    switch (action.type) {
        case TOGGLE_NUTRITION:
            return toggleNutritionalFacts(state, action);
        case SET_NUTRI_FACTS_IMAGE:
            return { ...state, nutritionalFactImage: action.src }
        case TOGGLE_CONTACT:
            return toggleContact(state, action);
        case TOGGLE_SINGLE_PRODUCT: return { ...state, singleEventOpen: action.bool };
        case TOGGLE_SINGLE_EVENT: return { ...state, singleEventOpen: action.bool };
        case TOGGLE_SEARCH: return { ...state, isSearchActive: action.bool };
        case PRODUCT_IMAGES_LOADING:
            return {
                ...state,
                productImagesLoading: action.bool
            }
        case GET_PRODUCTS_FAILED:
            return getProductsFailed(state, action)
        case GET_PRODUCTS_LOADING:
            return getProductsLoading(state, action)
        case GET_PRODUCTS_SUCCESS:
            return getProductsSuccess(state, action)
        case GET_RECIPES_FAILED:
            return getRecipesFailed(state, action)
        case GET_RECIPES_LOADING:
            return getRecipesLoading(state, action)
        case GET_RECIPES_SUCCESS:
            return getRecipesSuccess(state, action)
        case GET_EVENTS_FAILED:
            return getEventsFailed(state, action)
        case GET_EVENTS_LOADING:
            return getEventsLoading(state, action)
        case GET_EVENTS_SUCCESS:
            return getEventsSuccess(state, action)
        case UPDATE_VIEWED_LOCATION:
            return Object.assign({}, state, {
                hoveredCell: action.index
            })
        case GET_SINGLE_PRODUCT_LOADING: return { ...state, getSingleProductLoading: true }
        case TOGGLE_NAV:
            return toggleNav(state, action)
        default:
            return state;
    }
}

export default mainReducer;

